module.exports = __webpack_public_path__ + "img/Farm R.f1e0a072.png";